import { Text } from '@mantine/core'

import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'
import { CoinCategory } from '@/services/category'
import { formatMarketCap } from '@/utils/number/format'

export default function MarketCapColumn({ category }: { category: CoinCategory }) {
  const {
    amounts: [{ formattedValue }],
  } = useCurrencyAmounts({
    amounts: [Number(category.market_cap_native.amount)],
    valueFormatter: formatMarketCap,
    currencyFormatOptions: {},
  })

  return <Text variant="body1">{formattedValue}</Text>
}
